import React from 'react';

import Container from 'components/Container';
import Icon from 'components/Icon';

import styles from './styles.module.scss';

const Footer = () => {
	const currentYear = new Date().getFullYear();

	return (
		<footer className={styles.Footer}>
			<Container className={styles.Footer__Container}>
				<div>
					Выставки Музеев {currentYear}. Здесь собрана информация об основных
					событиях ведущих музеев России: афиша выставок, юбилеи музеев.
				</div>
				<div className={styles.Footer__Additional}>
					<small className={styles.Footer__Copyright}>
						&copy;2023&ndash;{currentYear} ФКУ Цифровая культура. Все права
						защищены
					</small>
					<a
						href="https://t.me/mincultrussia"
						target="_blank"
						className={styles.Footer__Contact}
					>
						<span className={styles.Footer__ContactFigure}>
							<Icon icon="telegram" className={styles.Footer__ContactIcon} />
						</span>
						Официальный канал Министерства культуры РФ
					</a>
				</div>
			</Container>
		</footer>
	);
};

export default Footer;
